import { Flex, Text } from "@chakra-ui/react";
import TableList from "components/TableList";
import { Header } from "components/Header";
import { useEffect, useState } from "react";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import InputComp from "components/InputComp";
import utils from "utils";
// import PaginationComp from "components/PaginationComp";
import storage from "utils/storage";
// import PaginationComp from "components/PaginationComp";

const headers = [
  "Daeler",

  {
    label: "Net Amount",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },

  {
    label: "Commission",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
];

// const items = [
//   {
//     id: 1,
//     Daeler: "DaelerBolton",
//     "Net Amount": "Refund",
//     Commission: "Bolton",
//   },
// ];

function CommissionSheets() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [activePage, setActivePage] = useState(1);

  const [regManDD, setRegManDD] = useState();
  const [regMan, setRegMan] = useState();

  const [dateStart, setDateStart] = useState(
    storage.get("appcatch")?.commissionsheets_datestart ||
      utils.dateToDateInput(
        new Date(new Date().setDate(new Date().getDate() - 7))
      )
  );

  const [dateEnd, setDateEnd] = useState(
    storage.get("appcatch")?.commissionsheets_dateend ||
      utils.dateToDateInput(new Date())
  );

  const getList = (data) => {
    if (!(data?.datestart && data?.dateend && data?.regmanagerid)) {
      return;
    }

    setIsLoading(true);
    api
      .getCommissionsheet({
        datestart: data?.datestart,
        dateend: data?.dateend,
        regmanagerid: data?.regmanagerid,
        // page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("res?.data", res?.data);

        if (res?.status === 200) {
          // if (data?.page) {
          //   setActivePage(data.page);
          // }

          const {
            paidcommission,
            paidoninvoice,
            paidonsale,
            unpaidcommission,
          } = res?.data;

          let tablearr = [];

          //   - before doing loop add a line like this
          //   ListBox1.AddRow ("Commission on Paid Invoices","","")

          //   - then add all rows from result  (LOOP START)
          // ListBox1.AddRow(rs.Field("companyname").StringValue, Format( rs.Field("total").DoubleValue, "#0.00") , Format( rs.Field("commission").DoubleValue, "#0.00"))

          // - add the value to 2 variables like this
          // paidnet = paidnet + rs.Field("total").DoubleValue
          //   paidtotal = paidtotal + rs.Field("commission").DoubleValue

          //   - show the values of paidnet and paid total (LOOP FINISH)
          //   ListBox1.AddRow( ""  , "--------", "--------")
          //   ListBox1.AddRow("Total:" ,  format(paidnet, "#0.00"), format(paidtotal, "#0.00"))

          if (paidcommission && paidcommission[0]) {
            const arr = [
              {
                c1: {
                  label: "Commission on Paid Invoices",
                  cellStyle: {
                    color: "textv2.brand",
                    fontWeight: "bold",
                    // maxWidth: "3rem",
                  },
                },

                c2: "",
                c3: "",
              },
            ];

            let paidnet = 0;
            let paidtotal = 0;

            paidcommission?.forEach((a) => {
              paidnet = paidnet + a.total;
              paidtotal = paidtotal + a.commission;

              arr.push({
                companyname: a.companyname,
                total: utils.formatAmountForTb(a.total),
                commission: utils.formatAmountForTb(a?.commission),
                data: a,
              });
            });

            arr.push({
              c1: " ",
              c2: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
              c3: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
            });

            arr.push({
              // c1: "Total:",
              c1: {
                label: "Total:",
                cellStyle: {
                  textAlign: "end",
                },
              },

              c2: utils.formatAmountForTb(paidnet),
              c3: utils.formatAmountForTb(paidtotal),
            });

            tablearr.push(...arr);
          }

          if (paidoninvoice && paidoninvoice[0]) {
            const arr = [
              {
                c1: {
                  label: "Commission on Invoiced Products",
                  cellStyle: {
                    color: "textv2.brand",
                    fontWeight: "bold",
                    // maxWidth: "3rem",
                  },
                },

                c2: "",
                c3: "",
              },
            ];

            let paidnet = 0;
            let paidtotal = 0;

            paidoninvoice?.forEach((a) => {
              paidnet = paidnet + a.total;
              paidtotal = paidtotal + a.commission;

              arr.push({
                companyname: a.companyname,
                total: utils.formatAmountForTb(a.total),
                commission: utils.formatAmountForTb(a?.commission),
                data: a,
              });
            });

            arr.push({
              c1: " ",
              c2: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
              c3: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
            });

            arr.push({
              // c1: "Total:",
              c1: {
                label: "Total:",
                cellStyle: {
                  textAlign: "end",
                },
              },

              c2: utils.formatAmountForTb(paidnet),
              c3: utils.formatAmountForTb(paidtotal),
            });

            tablearr.push(...arr);
          }

          if (paidonsale && paidonsale[0]) {
            const arr = [
              {
                c1: {
                  label: "Commission on Sold Products",
                  cellStyle: {
                    color: "textv2.brand",
                    fontWeight: "bold",
                    // maxWidth: "3rem",
                  },
                },

                c2: "",
                c3: "",
              },
            ];

            let paidnet = 0;
            let paidtotal = 0;

            paidonsale?.forEach((a) => {
              paidnet = paidnet + a.total;
              paidtotal = paidtotal + a.commission;

              arr.push({
                companyname: a.companyname,
                total: utils.formatAmountForTb(a.total),
                commission: utils.formatAmountForTb(a?.commission),
                data: a,
              });
            });

            arr.push({
              c1: " ",
              c2: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
              c3: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
            });

            arr.push({
              // c1: "Total:",
              c1: {
                label: "Total:",
                cellStyle: {
                  textAlign: "end",
                },
              },

              c2: utils.formatAmountForTb(paidnet),
              c3: utils.formatAmountForTb(paidtotal),
            });

            tablearr.push(...arr);
          }

          if (unpaidcommission && unpaidcommission[0]) {
            const arr = [
              {
                c1: {
                  label: "Potential Commission",
                  cellStyle: {
                    color: "textv2.brand",
                    fontWeight: "bold",
                    // maxWidth: "3rem",
                  },
                },

                c2: "",
                c3: "",
              },
            ];

            let paidnet = 0;
            let paidtotal = 0;

            unpaidcommission?.forEach((a) => {
              paidnet = paidnet + a.total;
              paidtotal = paidtotal + a.commission;

              arr.push({
                companyname: a.companyname,
                total: utils.formatAmountForTb(a.total),
                commission: utils.formatAmountForTb(a?.commission),
                data: a,
              });
            });

            arr.push({
              c1: " ",
              c2: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
              c3: {
                label: "-------------------",
                cellStyle: {
                  textAlign: "end",
                },
              },
            });

            arr.push({
              // c1: "Total:",
              c1: {
                label: "Total:",
                cellStyle: {
                  textAlign: "end",
                },
              },

              c2: utils.formatAmountForTb(paidnet),
              c3: utils.formatAmountForTb(paidtotal),
            });

            tablearr.push(...arr);
          }

          // setList(
          //   res.data.map((a) => ({
          //     companyname: a.companyname,
          //     total: a.total,
          //     commission: a?.commission,
          //     data: a,
          //   }))
          // );
          setList(tablearr);
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangeRegManDD = (data) => {
    setRegManDD(data.list ? [...data.list] : []);
    setRegMan(data?.item?.data?.userid);
    getList({
      datestart: dateStart,
      dateend: dateEnd,
      regmanagerid: data?.item?.data?.userid,
    });
    const appcatch = storage.get("appcatch") || {};
    appcatch.commissionsheets_regmanagerid = data?.item?.data?.userid;
    storage.set("appcatch", appcatch);
  };

  // const getRegionalManagers = async (data) => {
  //   setIsLoading(true);
  //   api.getCommissionsheetRegMan().then((res) => {
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       console.log("getRegionalManagers = ", res?.data);
  //       if (res?.data && res?.data[0]?.userid) {
  //         const l = res.data.map((a, index) => ({
  //           key: `reg-man-${index}`,
  //           value: `${a.companyname}-${index}`,
  //           label: a.companyname,
  //           data: a,
  //         }));

  //         if (data?.action === "useState" && defaultVal) {
  //           result.list = result?.list?.map((a, index) => {
  //             if (a.data.dealerid === defaultVal) {
  //               a.selected = true;
  //               result.index = index;
  //               result.item = a;
  //             } else {
  //               a.selected = false;
  //             }
  //             return a;
  //           });

  //           if (result?.item?.key && result?.list && result?.list[0]) {
  //             result.list[0].selected = true;
  //           } else {
  //             result.index = 0;
  //             result.item = result.list[0];
  //           }
  //         }

  //         setRegManDD(l);
  //       } else {
  //         setRegManDD([]);
  //       }
  //     } else {
  //       setRegManDD([]);
  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // };

  const onChangeDate = (v, action) => {
    const appcatch = storage.get("appcatch") || {};

    if (action === "date-start") {
      appcatch.commissionsheets_datestart = v;

      setDateStart(v);
      // if (v && dateEnd) {
      getList({
        datestart: v,
        dateend: dateEnd,
        regmanagerid: regMan,
      });
      // }
    } else if (action === "date-end") {
      appcatch.commissionsheets_dateend = v;

      setDateEnd(v);
      // if (dateStart && v) {
      getList({
        datestart: dateStart,
        dateend: v,
        regmanagerid: regMan,
      });
      // }
    }
    storage.set("appcatch", appcatch);
  };

  // const onChangePage = (data) => {
  //   if (data?.page === activePage) {
  //     return;
  //   }
  //   getList({
  //     page: data.page,
  //     datestart: dateStart,
  //     dateend: dateEnd,
  //     regmanagerid: regMan,
  //   });
  // };

  useEffect(() => {
    const appcatch = storage.get("appcatch") || {};

    utils.getRegionalManagers({
      setIsLoading,
      onChangeRegManDD,
      action: "useState",
      defaultVal: appcatch?.commissionsheets_regmanagerid,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Commission Sheets"} isLoading={isLoading} />

      <Flex
        width={"100%"}
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        mb="1rem"
      >
        <InputComp
          value={dateStart}
          onChange={(v) => onChangeDate(v, "date-start")}
          type="date"
        />
        <Text>To &nbsp;</Text>
        <InputComp
          value={dateEnd}
          onChange={(v) => onChangeDate(v, "date-end")}
          type="date"
        />
        <InputComp
          type={"dropdown"}
          items={regManDD}
          onChange={onChangeRegManDD}
        />

        {/* <Flex flexFlow={"wrap"} alignItems={'center'} gap={'2rem'}> */}
        {/* <InputComp type="date" /> */}
        {/* <Field.Label textStyle={fs}>Town</Field.Label> */}
        {/* <Text>To</Text> */}
        {/* <Input type="date" w={"10rem"} textStyle={fs} /> */}
        {/* <DropDown items={regManDD} onChange={onChangeRegManDD}/> */}
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        colGroup={["70%", "15%", "15%"]}
      />
      {/* <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      /> */}
    </Flex>
  );
}

export default CommissionSheets;
